<template>
  <div data-test-id="ComplaintsListComponent">
    <section v-if="showComplaints" data-test-id="ComplaintsSection">
      <div class="complaints-list">
        <div v-for="complaint in complaints" :key="complaint.id" class="complaints-item">
          <complaint
            :complaint="complaint"
            :class="{
              'selected-complaint': isSelected(complaint),
            }"
            @modify-case="selectComplaint"
          ></complaint>
        </div>
      </div>
      <div class="priorities mt-4">
        <div class="priority">
          <div class="priority-1" />
          Priority 1
        </div>
        <div class="priority">
          <div class="priority-2" />
          Priority 2
        </div>
        <div class="priority">
          <div class="priority-3" />
          Priority 3
        </div>
      </div>
    </section>
    <section v-if="!showComplaints" data-test-id="TagsSection">
      <div
        v-if="complaintSelected"
        class="complaint-header"
        data-test-id="SelectedComplaintHeader"
        :class="{ 'complaint-header-on': complaintSelected }"
        @click="showComplaintList()"
        @keydown.enter="showComplaintList()"
      >
        <div class="complaint-header-text">
          <div class="complaint-header-name">{{ complaintSelected.name }}</div>
          <div class="complaint-header-priority">Priority {{ complaintSelected.priority }}</div>
        </div>
        <div class="complaint-header-color" :style="`background-color: ${complaintSelected.color}`"></div>
      </div>
      <div
        v-if="complaintSelected"
        class="complaint-tags clean-scrollbar"
        :class="{ 'complaint-tags-on': complaintSelected }"
      >
        <div>
          <TagsList
            :sections="complaintSelected.sections"
            :color="complaintSelected.color"
            :twiage-case="twiageCase"
            @modify-case="onModifyCase"
          ></TagsList>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Complaint from "@/Case/components/Complaint";
import TagsList from "@/Case/components/TagsList";
import { CaseEvent, CaseUpdateEventType } from "@/Case/CaseEvent";

export default {
  name: "ComplaintsList",
  components: { Complaint, TagsList },
  props: {
    complaints: {
      type: Array,
      default: () => [],
    },
    twiageCase: {
      type: Object,
      default: () => undefined,
    },
  },
  data() {
    return {
      complaintSelected: undefined,
      showComplaints: true,
    };
  },
  watch: {
    complaints: function () {
      this.setComplaintSelected();
    },
  },
  mounted() {
    this.setComplaintSelected();
  },
  methods: {
    selectComplaint(event) {
      if (event.eventType === CaseUpdateEventType.complaint) {
        this.onModifyCase(event);
        this.showComplaints = false;
      }
    },
    showComplaintList() {
      this.showComplaints = true;
    },
    onModifyCase(event) {
      if (event.eventType === CaseUpdateEventType.complaint) {
        this.complaintSelected = event.data;
      }
      this.$emit(CaseEvent.MODIFY, event);
    },
    setComplaintSelected() {
      if (this.twiageCase && this.twiageCase.complaint) {
        this.complaintSelected = this.complaints.find((c) => c.id === this.twiageCase.complaint.id);
        if (this.complaintSelected) {
          this.showComplaints = false;
        }
      }
    },
    isSelected(complaint) {
      if (this.complaintSelected) {
        if (complaint.id === this.complaintSelected.id) {
          return true;
        }
      }
      return false;
    },
  },
};
</script>

<style scoped>
.complaints-list {
  display: flex;
  flex-wrap: wrap;
}
.complaints-item {
  width: 33.33%;
  min-height: 90px;
  padding: 0.2em;
  cursor: pointer;
}
.priorities {
  display: flex;
  flex-wrap: wrap;
  font-weight: bold;
}
.priorities .priority {
  width: 33.33%;
  white-space: nowrap;
}
.priorities .priority div {
  width: 15px;
  height: 15px;
  display: inline-block;
  margin-right: 4px;
}
.complaint-header {
  position: absolute;
  width: 100%;
  background-color: #222;
  border-bottom: 1px solid #000;
  box-sizing: border-box;
  cursor: pointer;
  height: 70px;
  padding: 1rem;
  top: -80px;
  transition: top 0.3s;
  display: flex;
  align-items: center;
}
.complaint-header-on {
  top: 0;
}
.complaint-header-name {
  font-size: 1.1rem;
  font-weight: bold;
  text-align: left;
}
.complaint-header-priority {
  font-size: 0.8rem;
  text-transform: uppercase;
  font-weight: bold;
  text-align: left;
}
.complaint-header-color {
  height: 50px;
  margin-left: auto;
  width: 50px;
}
.complaint-tags {
  width: 100%;
  box-sizing: border-box;
  overflow-y: auto;
  padding: 1rem;
  top: 95%;
  bottom: 0;
  position: absolute;
  transition: top 0.3s;
  background-color: #222;
  visibility: hidden;
}
.complaint-tags-on {
  top: 70px;
  visibility: visible;
}
.selected-complaint {
  border: 3px solid #6ad66a;
}
</style>
